import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			adPosConfig: {
				homeRecommand: [1, 2],
				homeRecommandPC: [3],
			},
			adsensConfig: {
				home_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_4: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_5: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				cal_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				cal_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				cal_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				detail_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				detail_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				detail_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				all_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-9524345982013195',
					'data-ad-slot': '7264082190',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},

				all: [
					{
						class: 'adsbygoogle',
						style: 'display:block',
						'data-ad-client': 'ca-pub-4688525518274277',
						'data-ad-slot': '1870648774',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
					},
					{
						class: 'adsbygoogle',
						style: 'display:block',
						'data-ad-client': 'ca-pub-4688525518274277',
						'data-ad-slot': '1870648774',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
					},
				],
			},

			domainConfig: {
				siteName: 'Drive Smart with Our Loans',
				designType: 2,
				siteIcon: '/icon/1.svg',
				IAMEMAIL: 'contact@smartcarsloans.com',
				IAmURL: 'readloft.com',
				ABOUTUS: 'We are a platform dedicated to bringing innovative AI-generated stories to life, offering an immersive experience for readers and writers alike. Join us for unique, evolving narratives.',
				meta: {
					title: ' | Smart solutions for hassle-free car loans.',
					des: 'Explore intelligent car loan solutions designed to simplify your financing experience and expedite your journey to ownership.',
				},
				firebase: {
					apiKey: 'AIzaSyANTXpxmJvBDjpHu7zXrmweD0HG4arA8k0',
					authDomain: 'project-6604139797178678943.firebaseapp.com',
					projectId: 'project-6604139797178678943',
					storageBucket: 'project-6604139797178678943.firebasestorage.app',
					messagingSenderId: '417753823474',
					appId: '1:417753823474:web:069438035661749658f86b',
					measurementId: 'G-PBLQRSGZXB',
				},
				ads: 'google.com, pub-9524345982013195, DIRECT, f08c47fec0942fa0',
				adsense: {
					scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9524345982013195',
				},
			},
			glossary: [],
			subprimeLendingInstitutions: [],
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			setGlossary(state, glossary) {
				state.glossary = glossary
			},
			setSubprimeLendingInstitutions(state, subprimeLendingInstitutions) {
				state.subprimeLendingInstitutions = subprimeLendingInstitutions
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			glossary: (state) => state.glossary,
			subprimeLendingInstitutions: (state) => state.subprimeLendingInstitutions,
		},
	})
}
